import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Slider,
  Tooltip,
  TextField,
  Collapse,
  Box,
  Chip,
  IconButton,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  LinearProgress,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faBell,
  faUserPlus,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsNoDataToDisplay from "highcharts/modules/no-data-to-display";
import CustomizerContext from "../../../../_helper/Customizer";
import { ShowError, ShowSucess } from "../../../../_helper/helper";
import { advanceSearch } from "../../../../_helper/services/advanceSearchv2";
import { useNavigate } from "react-router-dom";
import ApplicantsByGA from "../ApplicantsByGA/ApplicantsByGA";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Form,
  FormGroup,
  Input,
  ModalFooter,
  Spinner,
} from "reactstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  faArrowTrendUp,
  faCheck,
  faClock,
  faCoins,
  faHourglassClock,
  faListDropdown,
  faPersonCirclePlus,
  faPlus,
  faPodiumStar,
  faQuestion,
  faShieldCheck,
  faShieldXmark,
  faStars,
  faSuitcase,
  faTimesCircle,
} from "@fortawesome/pro-duotone-svg-icons";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { post, put } from "../../../../_helper/api_helper";
import CountdownTimer from "./CountdownTimer";
import TimeRemaining from "./TimeRemaining";
import { withStyles } from "@mui/styles";
import CountdownProgressBar from "./CountdownProgressBar";
import { utcToZonedTime } from "date-fns-tz";
import { getFormalApiErrorMessage } from "../../../../utils/apiError";

// Initialize the module for no-data-to-display
HighchartsNoDataToDisplay(Highcharts);

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    position: "relative",
    width: "100%",
  },
  colorPrimary: {
    backgroundColor: "#ffcccb", // Light color for remaining part
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

const ProgressBar = ({ value, max }) => {
  const percentage = ((value / max) * 100).toFixed(2);
  const remainingPercentage = (100 - percentage).toFixed(2);

  return (
    <Box position="relative" display="flex" alignItems="center" width="100%">
      <BorderLinearProgress variant="determinate" value={percentage} />
      {/* <Box position="absolute" top={0} left="10px" color="#000">
        <Typography variant="body2">
          Notified: {percentage}% ({value})
        </Typography>
      </Box>
      <Box position="absolute" top={0} right="10px" color="#000">
        <Typography variant="body2">
          Remaining: {remainingPercentage}% ({max - value})
        </Typography>
      </Box> */}
    </Box>
  );
};

const isExpired = (createdOnString) => {
  if (!createdOnString) return false;
  const createdDate = new Date(createdOnString);
  const expiryDate = new Date(createdDate);
  expiryDate.setDate(expiryDate.getDate() + 10);

  const today = new Date();

  return today > expiryDate;
};

const AnnouncementDetail = ({ id, cardData, setToggleApi }) => {
  const {
    setShowGaSummary,
    showGaSummary,
    setEligibilityTableShow,
    setApplicantTableShow,
  } = useContext(CustomizerContext);
  const [data, setData] = useState({
    id,
    eligibilityIDs: ["Ea-1", "Ea-2", "Ea-3", "Ea-4"],
    multipleElgbilityIds: "",
    totalEligible: 0,
    totalNotified: 0,
    response: 0,
    declined: 0,
    noAnswer: 0,
    remaining: 0,
    pendingResponse: 0,
    createdOn: "2024-06-01",
    lastUpdateOn: "2024-06-20",
    Announcement_id: "",
    Grade: "",
    HourlyRateRange: 0,
    POSITION_NO: "",
    PositionTitle: "",
    SalaryRange: 0,
    StepRange: 0,
    Vacancy: 0,
    Remaindays: 0,
    ANNOUNCEMENT_DATE_CLOSED: new Date(),
    department: "",
    Hr_controls: "",
    responseDay: 0,
  });

  const [notifyApplicants, setNotifyApplicants] = useState(data.totalNotified);
  const [modal, setModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [detailedData, setDetailedData] = useState([]);
  const [items, setItems] = useState([
    { id: "Item-1", details: "Details of Item-1" },
    { id: "Item-2", details: "Details of Item-2" },
    // Add more items as needed
  ]);
  const [applicantsNotifyModal, setApplicantsNotifyModal] = useState(false);
  const [message, setMessage] = useState("");
  const [notifyLoader, setNotifyLoader] = useState(false);
  const [notifyReached, SetNotifyReached] = useState(1);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [jobOpenings, setJobOpenings] = useState(0);
  const [notifyMoreData, setNotifyMoreData] = useState({});
  const [ElaspTimeOver, setElaspTimeOver] = useState(false);
  const [responseDayModal, setResponseDayModal] = useState(false);
  const [responseDayInput, setResponseDayInput] = useState(0);
  const [responseDayLoader, setResponseDayLoader] = useState(false);

  console.log(notifyReached, "notifyReached1221");

  const toggle = () => setModal(!modal);
  const navigate = useNavigate();

  const options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 280,
      width: 310,
      events: {
        load: function () {
          this.update({
            exporting: {
              enabled: false,
            },
          });
        },
      },
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
          distance: -30,
          color: "black",
        },
      },
    },
    series: [
      {
        innerSize: "50%",
        data: [
          { name: "Available", y: data.response, color: "lightgreen" },
          { name: "Unavailable", y: data.declined, color: "lightcoral" },
          {
            name: !ElaspTimeOver ? "Pending Response" : "No Response",
            y: data.noAnswer,
            color: true ? "#ffd43b" : "lightgray",
          },
          { name: "Remaining", y: data.remaining, color: "lightblue" },
        ],
      },
    ],
  };

  const handleSliderChange = (event, newValue) => {
    setNotifyApplicants(newValue);
  };

  const getSummary = async () => {
    const params = [
      {
        columnName: "announcement_id",
        value: showGaSummary,
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
    ];
    const payload = {
      tableName: "Eligibility-Announcement-Id-Summary",
      searchParams: JSON.stringify(params),
      columns: "*",
      location: "pmis-global",
      pageNumber: 1,
      pageSize: 100,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    };
    try {
      const response = await advanceSearch(payload);
      const { results } = response;
      const apiData = results[0];
      setData({
        id: apiData.General_Availibility_ID,
        eligibilityIDs: apiData?.Total_Notify_Eligibility_IDs?.split(","),
        totalEligible: apiData.Total_Eligible,
        totalNotified: apiData.Total_Notify,
        remaining: apiData.Total_Eligible - apiData.Total_Notify,
        pendingResponse: apiData.Total_Notify - apiData.Responded_Applicant,
        response: apiData.Accepted_Applicant,
        declined: apiData.Rejected_Applicant,
        noAnswer: apiData.Total_Notify - apiData.Responded_Applicant,
        createdOn: apiData?.Created_On?.split("T")?.[0] || new Date(),
        lastUpdateOn: apiData?.Created_On?.split("T")?.[0] || new Date(),
        Vacancy: apiData?.Vacancy ?? 0,
        multipleElgbilityIds: apiData?.Notifye_ELIGIBILITY_IDS,
        ANNOUNCEMENT_DATE_CLOSED: apiData?.ANNOUNCEMENT_DATE_CLOSED,
        Remaindays: apiData?.Remaindays ?? 0,
        responseDay: apiData?.Response_DayRequired ?? 0,
      });
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to load General Availability summary details at this time. Please try again shortly."
        )
      );
    }
  };

  useEffect(() => {
    // getSummary();
    const apiData = { ...cardData };
    setData({
      id: apiData.General_Availibility_ID,
      eligibilityIDs: apiData?.ELIGIBILITY_IDS?.split(","),
      totalEligible: apiData.Total_Eligible,
      totalNotified: apiData.Total_Notify,
      remaining: apiData.Total_Eligible - apiData.Total_Notify,
      response: apiData.Accepted_Applicant,
      declined: apiData.Rejected_Applicant,
      noAnswer: apiData.Total_Notify - apiData.Responded_Applicant,
      pendingResponse: apiData.Total_Notify - apiData.Responded_Applicant,
      createdOn: apiData?.Created_On,
      lastUpdateOn: apiData?.Updated_On,
      Announcement_id: apiData?.Announcement_id?.trim(),
      Grade: apiData?.Grade || "N/A",
      HourlyRateRange: apiData?.HourlyRateRange || 0,
      POSITION_NO: apiData?.POSITION_NO?.trim() || "N/A",
      PositionTitle: apiData?.PositionTitle?.trim() || "N/A",
      SalaryRange: apiData?.SalaryRange || 0,
      StepRange: apiData?.StepRange || 0,
      Vacancy: apiData?.Vacancy || 0,
      multipleElgbilityIds: apiData?.Notifye_ELIGIBILITY_IDS,
      ANNOUNCEMENT_DATE_CLOSED: apiData?.ANNOUNCEMENT_DATE_CLOSED,
      Remaindays: apiData?.Remaindays ?? 0,
      department: apiData?.DepartmentName?.trim() || "N/A",
      Hr_controls:
        apiData?.Hr_controls ||
        apiData?.hr_controls ||
        apiData?.HrControl ||
        apiData?.hrControl ||
        apiData?.Hrcontrols ||
        apiData?.hrcontrols ||
        "",
      responseDay: apiData?.Response_DayRequired ?? 0,
    });
    setNotifyApplicants(apiData.Total_Notify);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      setFilteredItems(
        detailedData.filter((item) =>
          item.APPLICANT_NAME.toLowerCase().includes(lowercasedSearchTerm)
        )
      );
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, detailedData]);

  const getStatusIcon = (status) => {
    let pending_response = true;
    switch (status) {
      case "Accept":
        return <FontAwesomeIcon icon={faShieldCheck} />;
      case "Decline":
        return <FontAwesomeIcon icon={faShieldXmark} />;
      case "No Response":
        return <FontAwesomeIcon icon={faShieldAlt} />;
      default:
        if (pending_response)
          return <FontAwesomeIcon icon={faHourglassClock} />;
        else return <FontAwesomeIcon icon={faShieldAlt} />;
    }
  };

  const getStatusIconWithColor = (status) => {
    let pending_response = true;
    switch (status) {
      case "Accept":
        return (
          <FontAwesomeIcon
            icon={faShieldCheck}
            style={{ color: "lightgreen" }}
          />
        );
      case "Decline":
        return (
          <FontAwesomeIcon
            icon={faShieldXmark}
            style={{ color: "lightcoral" }}
          />
        );
      case "No Response":
        return (
          <FontAwesomeIcon icon={faShieldAlt} style={{ color: "lightgray" }} />
        );
      default:
        if (pending_response)
          return (
            <FontAwesomeIcon
              icon={faHourglassClock}
              style={{ color: "#ffd43b" }}
            />
          );
        else
          return (
            <FontAwesomeIcon
              icon={faShieldAlt}
              style={{ color: "lightgray" }}
            />
          );
    }
  };

  const getStatus = (status) => {
    let pending_response = !ElaspTimeOver;
    switch (status) {
      case "Accept":
        return "Available";
      case "Decline":
        return "Unavailable";
      default:
        if (pending_response) return "Pending Response";
        else return "No Response";
    }
  };

  const getBackgroundForStatus = (status) => {
    let pending_response = true;
    switch (status) {
      case "Accept":
        return "lightgreen";
      case "Decline":
        return "lightcoral";
      default:
        if (pending_response) return "#ffd43b";
        else return "lightgray";
    }
  };

  const notifyMoreHandler = () => {
    // setApplicantTableShow(false);
    // setTimeout(
    //   () =>
    //     navigate("/generate-availability-list", {
    //       state: {
    //         notifyMore: true,
    //         AnnouncementID: showGaSummary,
    //         generalID: data?.id,
    //       },
    //     }),
    //   0
    // );
    toggle();
  };

  const customStyles = {
    maxWidth: "60%",
    width: "500",
    height: "40%",
  };

  const fetchDetails = async () => {
    // setLoadingDetails(true);
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/PMISAdvanceSearch/pmis-global?pageNumber=1&pageSize=100`;
    const payload = {
      tableName: "GENERAL-AVAIL",
      searchParams: `[{"columnName":"GENERAL_AVAILIBILITY_ID","value":"${data.id}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
      columns: "*",
      location: "pmis-global",
      pageNumber: 1,
      pageSize: 100,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    };

    try {
      const response = await post(url, payload);
      setDetailedData(response?.results || []);
      return response?.results || [];
    } catch (error) {
      throw error;
    } finally {
      // setLoadingDetails(false);
    }
  };

  const createExpandData = (dataFromApi1, notificationData) => {
    console.log(dataFromApi1, notificationData, "notificationData0040");
    let dataFromApi1temp = dataFromApi1.map((item) => {
      return {
        ...item,
        no_of_notification: 1,
        notification_dates: item.Notifiedon,
      };
    });
    for (let item of dataFromApi1temp) {
      let notifyString = "";
      for (let notify of notificationData) {
        if (item?.APPLICATION_ID?.trim() == notify?.SourceId?.trim()) {
          if (notifyString) notifyString += "," + notify?.NotifiedOn;
          else notifyString += notify?.NotifiedOn;
        }
      }
      if (notifyString) {
        item.notification_dates = notifyString;
      }
      if (notifyString.split(",").length == 3) {
        SetNotifyReached(3);
        item.no_of_notification = 3;
      }
      if (notifyString.split(",").length == 2) {
        SetNotifyReached(2);
        item.no_of_notification = 2;
      }
    }
    return dataFromApi1temp;
  };

  const fetchNotification = async (dataFromApi1) => {
    // setLoadingDetails(true);
    // const url = `${process.env.REACT_APP_API_DOTNET_URL}/PMISAdvanceSearch/pmis-global?pageNumber=1&pageSize=100`;
    let applicationIds = dataFromApi1.map((item) =>
      item.APPLICATION_ID?.trim()
    );
    const payload = {
      tableName: "fn_Notification_by_GENERAL_AVAILIBILITY_IDnAppicationID",
      searchParams: `[{"columnName":"GENERAL_AVAILIBILITY_ID","value":"${data.id
        }","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"AppicationID","value":"${applicationIds.length == 1
          ? applicationIds[0]
          : applicationIds.join(",")
        }","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
      columns: "*",
      location: "JobApplicant-global",
      pageNumber: 1,
      pageSize: 999,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    };

    try {
      const response = await advanceSearch(payload);
      console.log(response?.results, "fetchNotification1221");
      return createExpandData(dataFromApi1, response?.results || []);
      // setDetailedData(response?.results || []);
    } catch (error) {
      throw error;
      // ShowError(error?.message ?? "Something went wrong");
    } finally {
      // setLoadingDetails(false);
    }
  };

  const detailHandler = () => {
    setLoadingDetails(true);
    // fetchDetails();
    fetchDetails()
      .then((dataFromApi1) => fetchNotification(dataFromApi1))
      .then((dataFromApi2) => {
        console.log("Data from both APIs:", { dataFromApi2 });
        setDetailedData(dataFromApi2 || []);
      })
      .catch((error) => {
        console.error("Error in one of the API calls:", error);
        ShowError(
          getFormalApiErrorMessage(
            error,
            "We are unable to load applicant details at this time. Please try again shortly."
          )
        );
      })
      .finally(() => {
        setLoadingDetails(false);
      });
  };

  const handleExpandClick = () => {
    // if (!expanded) {
    //   detailHandler();
    // }

    // setExpanded(!expanded);
    navigate("/view-general-availability/applicants-detail", {
      state: { ...data },
    });
  };

  const formatDateToMMDDYYYY = (date) => {
    if (date) {
      return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
    return "N/A";
  };

  const notifyApplicantsHandler = async () => {
    setNotifyLoader(true);
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/SendNotificationBulk`;
    const payloadData = detailedData
      .filter((item) => item.status == null)
      .map((notifyData) => {
        return {
          applicanT_SSN: notifyData.APPLICANT_SSN?.trim(),
          applicatioN_ID: notifyData.APPLICATION_ID?.trim(),
          generaL_AVAILIBILITY_ID: notifyData.GENERAL_AVAILIBILITY_ID,
        };
      });
    try {
      const response = await post(url, {
        data: payloadData,
        text: message,
      });
      ShowSucess("Aplicants Notified");
      setApplicantsNotifyModal(!applicantsNotifyModal);
      detailHandler();
      // setToggleApiCall(!toggleApiCall);
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to send applicant notifications at this time. Please try again shortly."
        )
      );
    } finally {
      setNotifyLoader(false);
    }
  };

  const handleapplicantsNotifyModal = () => {
    setApplicantsNotifyModal(!applicantsNotifyModal);
  };

  const toggleResponseDayModal = () => {
    setResponseDayInput(data.responseDay);
    setResponseDayModal(!responseDayModal);
  };

  const updateResponseDayHandler = async () => {
    if (Number(responseDayInput) <= 0) {
      ShowError("Please enter a Response Day greater than 0");
      return;
    }
    try {
      setResponseDayLoader(true);
      const url = `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/ExtendResponseDay?general_avaibility_id=${data.id}&responseDayExtended=${Number(responseDayInput)}`;
      await put(url, {});
      ShowSucess("Response Day updated successfully");
      setData((prev) => ({ ...prev, responseDay: Number(responseDayInput) }));
      setToggleApi((prev) => !prev);
      setResponseDayModal(false);
    } catch (error) {
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to update the Response Day at this time. Please try again shortly."
        )
      );
    } finally {
      setResponseDayLoader(false);
    }
  };

  const handleModalSubmit = async () => {
    try {
      setSubmitLoader(true);
      const { Announcement_id, eligibilityIDs, id, multipleElgbilityIds } =
        notifyMoreData;
      const payload = {
        announcement_id: Announcement_id,
        eligibility_list:
          eligibilityIDs.length == 1
            ? eligibilityIDs[0]
            : eligibilityIDs.join(","),
        applicant_to_include: Number(jobOpenings),
        general_avaibility_id: id,
        vacancy: 0,
      };
      // ||eligibilityIDs.length==1?eligibilityIDs[0]:eligibilityIDs.join(",")
      // console.log(multipleElgbilityIds,payload,"multipleElgbilityIds12221")
      const response = await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/GenerateGeneralAvaibility`,
        payload
      );
      ShowSucess("Submitted succesfully");
      setToggleApi((prev) => !prev);
      toggle();
    } catch (error) {
      console.log(error?.message ?? "Somethig went wrong");
      ShowError(
        getFormalApiErrorMessage(
          error,
          "We are unable to generate the General Availability list at this time. Please try again shortly."
        )
      );
    } finally {
      setSubmitLoader(false);
    }
  };

  const addTenDays = (dateString) => {
    let date = new Date(dateString);
    date.setDate(date.getDate() + 10);
    let newDateString = date.toISOString();
    return newDateString;
  };

  const timeZone = "Pacific/Guam";

  const checkOpen = (dateString) => {
    if (!dateString) return false;
    const now = utcToZonedTime(new Date(), timeZone);
    const endDate = new Date(dateString);
    return now < endDate;
  };

  const certListStatus = cardData?.CERT_LIST_STATUS;
  const isCertListCreated = Boolean(certListStatus && certListStatus.trim() !== "");

  const hasExpired = isExpired(data.createdOn);
  const gg1RecruitmentIds = String(data.Hr_controls || "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
  const visibleGg1RecruitmentIds = gg1RecruitmentIds.slice(0, 3);
  const hiddenGg1RecruitmentIds = gg1RecruitmentIds.slice(3);
  const hiddenGg1Indicators = hiddenGg1RecruitmentIds
    .map((_, index) => `+${index + 1}`)
    .join(" ");

  const expiredCardStyle = {
    backgroundColor: "#fafafa",
    border: "1px solid #e0e0e0",
    opacity: 0.8,
  };

  return (
    <>
      <Card
        style={{
          margin: "10px",
          marginLeft: "0",
          padding: "0px",
          position: "relative",
          borderRadius: "1rem",
          position: expanded ? "sticky" : "relative",
          top: expanded ? "0" : "auto",
          zIndex: expanded ? 1000 : "auto",
          // ...(hasExpired && expiredCardStyle),
        }}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2.4, paddingRight: "4px" }}>
            <CardHeader
              title={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box >
                    <Typography variant="h6" style={{ marginRight: "10px" }}>
                      Recruitment Id: {data.id}
                    </Typography>
                    {/* <br /> */}
                    <Typography variant="subtitle1" style={{ margin: "0px", padding: "0px" }}>Department: {data.department}</Typography>
                  </Box>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      // marginBottom: "10px",
                      fontSize: "16px",
                    }}
                  >
                    <Tooltip title="Available">
                      <Typography
                        variant="body2"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FontAwesomeIcon
                          icon={faShieldCheck}
                          style={{ marginRight: "5px", color: "lightgreen" }}
                        />
                        Available:{" "}
                        <Chip
                          label={data.response}
                          style={{
                            backgroundColor: "lightgreen",
                            marginLeft: "5px",
                          }}
                          size="small"
                        />
                      </Typography>
                    </Tooltip>
                    <Tooltip title="Unavailable">
                      <Typography
                        variant="body2"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FontAwesomeIcon
                          icon={faShieldXmark}
                          style={{ marginRight: "5px", color: "lightcoral" }}
                        />
                        Unavailable:{" "}
                        <Chip
                          label={data.declined}
                          style={{
                            backgroundColor: "lightcoral",
                            marginLeft: "5px",
                          }}
                          size="small"
                        />
                      </Typography>
                    </Tooltip>
                    <Tooltip
                      title={
                        !ElaspTimeOver ? "Pending Response" : "No Response"
                      }
                    >
                      <Typography
                        variant="body2"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <FontAwesomeIcon
                          icon={!ElaspTimeOver ? faHourglassClock : faShieldAlt}
                          style={{
                            marginRight: "5px",
                            color: !ElaspTimeOver ? "#ffd43b" : "lightgray",
                          }}
                          size="18px"
                        />
                        {!ElaspTimeOver ? "Pending Response" : "No Response"}:{" "}
                        <Chip
                          label={data.noAnswer}
                          style={{
                            backgroundColor: !ElaspTimeOver
                              ? "#ffd43b"
                              : "lightgray",
                            marginLeft: "5px",
                          }}
                          size="small"
                        />
                      </Typography>
                    </Tooltip>
                  </div>
                </div>
              }
              subheader={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: "12px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", alignItems: "center", margin: '5px 0px' }}>
                      <Typography
                        variant="body2"
                        style={{ marginRight: "10px", marginTop: "-10px" }}
                      >
                        Announcement Id: {data.Announcement_id}
                      </Typography>
                      <Chip
                        label={
                          checkOpen(data?.ANNOUNCEMENT_DATE_CLOSED)
                            ? "Open"
                            : "Close"
                        }
                        style={{
                          backgroundColor: checkOpen(
                            data?.ANNOUNCEMENT_DATE_CLOSED
                          )
                            ? "lightgreen"
                            : "lightcoral",
                          marginLeft: "5px",
                          marginTop: "-10px",
                        }}
                        size="small"
                      />
                      {/* <Tooltip
                        title={
                          isCertListCreated
                            ? "A certification list has already been created for this announcement."
                            : "A certification list hasn't been created for this announcement yet."
                        }
                        arrow
                      >
                        <Chip
                          label={
                            isCertListCreated
                              ? "Certification List Created"
                              : "Certification List Not Created"
                          }
                          style={{
                            backgroundColor: isCertListCreated
                              ? "lightgreen"
                              : "lightcoral",
                            marginLeft: "5px",
                            marginTop: "-10px",
                          }}
                          size="small"
                        />
                      </Tooltip> */}
                    </div>
                    <Typography
                      variant="body2"
                      style={{ marginRight: "10px" }}
                    >
                      GG1 Recruitment Id:{" "}
                      {visibleGg1RecruitmentIds.length
                        ? visibleGg1RecruitmentIds.join(", ")
                        : "N/A"}
                      {hiddenGg1RecruitmentIds.length > 0 && (
                        <>
                          {" "}
                          <Tooltip
                            title={hiddenGg1RecruitmentIds.join(", ")}
                            arrow
                          >
                            <span
                              style={{
                                color: "#1976d2",
                                cursor: "pointer",
                                textDecoration: "underline dotted",
                              }}
                            >
                              {hiddenGg1Indicators}
                            </span>
                          </Tooltip>
                        </>
                      )}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{ marginRight: "10px", marginTop: "-5px" }}
                    >
                      No of Openings: {data.Vacancy}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Typography variant="body1" style={{ marginRight: "4px" }}>
                      Notified Meter:{" "}
                    </Typography>
                    <Slider
                      value={notifyApplicants}
                      onChange={handleSliderChange}
                      aria-labelledby="notify-applicants-slider"
                      min={0}
                      max={data.totalEligible}
                      style={{ width: "150px", marginRight: "4px" }}
                      valueLabelDisplay="auto"
                    />
                    <Tooltip title="Notify more applicants">
                      <IconButton
                        onClick={() => {
                          setNotifyMoreData(data);
                          notifyMoreHandler();
                        }}
                        style={{
                          backgroundColor: "#1976d2",
                          color: "white",
                          borderRadius: "50%",
                          padding: "0px",
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} size={2} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              }
              style={{ paddingBottom: "10px" }}
            />
            <CardContent style={{ fontSize: "12px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faSuitcase}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Position: {data.POSITION_NO}-{data.PositionTitle}
                    </Typography>
                  </div>
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faSuitcase}
                      style={{ marginRight: "5px",color:"lightblue" }}
                    />
                    <Typography variant="body1">
                      Position Name: {data.PositionTitle}
                    </Typography>
                  </div> */}
                </div>

              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faUsers}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Eligible Applicants: {data.totalEligible}
                    </Typography>
                  </div>
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faUserPlus}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Remaining Eligible Applicants:{" "}
                      {data.totalEligible - data.totalNotified}
                    </Typography>
                  </div> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faListDropdown}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Eligibility IDs: {data?.eligibilityIDs?.join(",")}
                    </Typography>
                  </div>
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "5px",
                  }}
                > */}
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon
                      icon={faUserPlus}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      No of Applicants Needed:{" "}
                      {data.Vacancy + 6 - data.response}
                    </Typography>
                  </div> */}
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon
                      icon={faPersonCirclePlus}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                  <Typography variant="body1" >
                   Remaining: {data.totalEligible - data.totalNotified}
                </Typography>
                </div> */}
                {/* </div> */}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // gap: "16px",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faBell}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Applicants Notified: {data.totalNotified}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faArrowTrendUp}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">Step: {data.StepRange}</Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faStars}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">Grade: {data.Grade}</Typography>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "8px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCoins}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Rate: ${data.HourlyRateRange ?? "N/A"}
                    </Typography>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon
                      icon={faCoins}
                      style={{ marginRight: "5px", color: "lightblue" }}
                    />
                    <Typography variant="body1">
                      Salary: ${data.SalaryRange ?? "N/A"}
                    </Typography>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row-reverse",
                }}
              >
                <Typography variant="body2" style={{ marginBottom: "10px" }}>
                  Created On: {formatDateToMMDDYYYY(data.createdOn)} Last Update
                  On: {formatDateToMMDDYYYY(data.lastUpdateOn)}
                </Typography>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <Tooltip title="General Availability Elasped Time" arrow>
                    <Typography variant="body2">
                      GA Elasped Time
                    </Typography>
                  </Tooltip>
                  <CountdownTimer
                    targetDate={data.createdOn}
                    label="Elapsed Time Countdown"
                  />
                </div>
                <CountdownProgressBar
                  targetDate={data.createdOn}
                  setElaspTimeOver={setElaspTimeOver}
                  data={data}
                />
              </div>
            </CardContent>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'grid', placeItems: 'center' }}>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
            <Box mt={0} sx={{ padding: "0 8px" }}>
              <Typography variant="body1">
                <FontAwesomeIcon
                  icon={faUsers}
                  size="small"
                  color="lightblue"
                  fontSize={"12px"}
                />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                  Eligible Applicants: {data.totalEligible}
                  <Button variant="outlined" size="small" onClick={toggleResponseDayModal}>
                    Extend Response Day Limit: {data?.responseDay}
                  </Button>
                </div>
                <ProgressBar
                  value={data.totalNotified}
                  max={data.totalEligible}
                />
              </Typography>
              <Box
                display="flex"
                justifyContent="space-between"
                width="100%"
                mb={1}
              >
                <Box display="flex" gap={1} alignItems="center">
                  <Box
                    width={10}
                    height={10}
                    bgcolor="#1a90ff"
                    borderRadius="50%"
                    mb={0}
                  />
                  <Typography variant="body2">
                    Notified ({data.totalNotified})
                  </Typography>
                </Box>
                <Box display="flex" gap={1} alignItems="center">
                  <Box
                    width={10}
                    height={10}
                    bgcolor="#ffcccb"
                    borderRadius="50%"
                    mb={0}
                  />
                  <Typography variant="body2">
                    Remaining ({data.totalEligible - data.totalNotified})
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            position: "absolute",
            bottom: "20px",
            left: "250px",
          }}
        >
          {/* <div style={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Typography variant="body2">
           Elasped Time :
          </Typography>
        <CountdownTimer targetDate={data.createdOn} label="Elapsed Time Countdown" />
        </div> */}
          {/* <div style={{display:"flex", gap:"5px",alignItems:"center"}}>
          <Typography variant="body2">
          Pending Time :
          </Typography>
          <TimeRemaining targetDate={addTenDays(data.createdOn)} />
        </div> */}
        </div>
        <Button
          variant="outlined"
          // color="primary"
          onClick={handleExpandClick}
          style={{ position: "absolute", bottom: "5px", left: "15px" }}
          endIcon={expanded ? <ArrowDropUp /> : <ArrowDropDown />}
        >
          {expanded ? "Hide Applicants Notified" : "List Applicants Notified"}
        </Button>
        {/* {hasExpired && (
        <Typography
          variant="body1"
          sx={{
            color: "error.main",
            fontWeight: "bold",
            position: 'absolute',
            left: '625px', 
            bottom: '20px',
            fontSize: '24px'
          }}
        >
          GA - Expired
        </Typography>
      )} */}
      </Card>
      {expanded && (
        <Box style={{ marginTop: "20px", marginLeft: "40px" }}>
          <Box style={{ borderLeft: "2px solid #000", paddingLeft: "10px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ width: "560px", maxWidth: "50%" }}>
                <TextField
                  label="Name, Application Number ..."
                  variant="outlined"
                  fullWidth
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: "0px" }}
                  size="small"
                />
              </div>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  let text =
                    notifyReached == 2
                      ? "Please let us know if you are available for the position. If we do not hear from you, we will assume you are no longer interested and proceed with other candidates."
                      : "This is follow-up message regarding your availability, please respond";
                  setMessage(text);
                  handleapplicantsNotifyModal();
                }}
                disabled={notifyReached == 3}
              >
                Notify Pending Response Applicants
              </Button>
            </div>
            {loadingDetails ? (
              <CircularProgress />
            ) : (
              filteredItems.map((item, index) => (
                <Accordion key={index} defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    style={{ position: "relative" }}
                  >
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: "bold" }}
                    >
                      {item.APPLICANT_NAME}
                    </Typography>
                    <Chip
                      icon={getStatusIcon(item.status)}
                      label={getStatus(item.status)}
                      style={{
                        marginLeft: "8px",
                        backgroundColor: getBackgroundForStatus(item.status),
                      }}
                      size="small"
                    />
                    {/* <Typography variant="subtitle2" style={{ marginLeft: "auto" }}>{getStatusIcon(item.status)} {getStatus(item.status)}</Typography> */}
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" style={{ marginTop: "-29px" }}>
                      Last Notified on:{" "}
                      {new Date(item.Notifiedon).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </Typography>
                    <div
                      style={{ display: "flex", marginTop: "10px", gap: "8px" }}
                    >
                      {/* <Typography variant="body2">SSN: {item.APPLICANT_SSN}</Typography> */}
                      <Typography variant="body2">
                        Application ID: {item.APPLICATION_ID}
                      </Typography>
                      <Typography variant="body2">
                        Evaluation Rating: {item.EVALUATION_RATING}
                      </Typography>
                      <Typography variant="body2">
                        Number of Notifications: {item?.no_of_notification || 3}
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "4px",
                        marginBottom: "4px",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          // flexDirection:"column",
                          gap: "8px",
                          position: "absolute",
                          top: "10px",
                          right: "50px",
                          // alignItems: "center",
                        }}
                      >
                        <ul
                          style={{
                            // border: "1px solid #ccc",
                            padding: "5px",
                            borderRadius: "5px",
                            listStyle: "none",
                            margin: 0,
                          }}
                        >
                          <li
                            style={{
                              display: "block",
                              marginRight: "10px",
                              border: "1px solid lightblue",
                              padding: "4px",
                            }}
                          >
                            <Typography variant="body2">
                              Notification Dates
                            </Typography>
                          </li>
                          {(
                            item?.notification_dates ||
                            "2024-06-27T22:56:15.753,2024-06-25T22:56:15.753,2024-06-22T22:56:15.753"
                          )
                            ?.split(",")
                            ?.reverse()
                            ?.map((date, idx) => {
                              const getOrdinalSuffix = (n) => {
                                const s = ["th", "st", "nd", "rd"],
                                  v = n % 100;
                                return n + (s[(v - 20) % 10] || s[v] || s[0]);
                              };
                              const formattedDate = new Date(
                                date
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              });
                              return (
                                <li
                                  key={idx}
                                  style={{
                                    display: "block",
                                    marginRight: "10px",
                                    border: "1px solid lightblue",
                                    padding: "4px",
                                  }}
                                >
                                  <span style={{ width: "40px" }}>
                                    {getOrdinalSuffix(idx + 1)}:{" "}
                                  </span>
                                  {getStatusIconWithColor(item.status)}
                                  {formattedDate}
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                        }}
                      >
                        {/* <Typography variant="body2">SSN: {item.APPLICANT_SSN}</Typography> */}
                        <Typography variant="body2">
                          Applicant ID: {item?.APPLICANT_ID ?? "N/A"}
                        </Typography>
                        <Typography variant="body2">
                          Eligibility List: {item?.ELIGIBILITY_ID?.trim()}
                        </Typography>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))
            )}
          </Box>
        </Box>
      )}

      <Modal
        isOpen={modal}
        toggle={toggle}
      // style={customStyles}
      >
        <div className="modal-content">
          <ModalHeader
            toggle={toggle}
          // close={
          //   <button
          //     className="close"
          //     onClick={toggle}
          //     style={{ fontSize: "47px", height: "40px", width: "74px" }}
          //   >
          //     &times;
          //   </button>
          // }
          >
            Notify More Applicants
          </ModalHeader>
          <ModalBody>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                }}
              >
                <FontAwesomeIcon
                  icon={faUserPlus}
                  style={{ marginRight: "5px", color: "lightblue" }}
                />
                <Typography variant="body1">
                  Remaining Eligible Applicants:{" "}
                  {data.totalEligible - data.totalNotified}
                </Typography>
              </div>
              <Input
                type="number"
                value={jobOpenings}
                onChange={(e) => setJobOpenings(e.target.value)}
                placeholder="Enter number of Applicants to notify"
              />
              {/* {jobOpenings > 0 && (
                  <strong>
                    {state?.notifyMore?Number(jobOpenings):Number(jobOpenings) + 4} applicants will be notified
                  </strong>
                )} */}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                handleModalSubmit();
              }}
              disabled={
                submitLoader ||
                jobOpenings == 0 ||
                data.totalEligible - data.totalNotified < jobOpenings
              }
              style={{ display: "flex", gap: "2px" }}
            >
              {submitLoader && <Spinner size="sm" />}
              Submit
            </Button>{" "}
            <Button color="secondary" onClick={toggle} disabled={submitLoader}>
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>

      {/* Modal for updating Response Day */}
      <Modal isOpen={responseDayModal} toggle={toggleResponseDayModal}>
        <ModalHeader toggle={toggleResponseDayModal}>
          Update Response Day
        </ModalHeader>
        <ModalBody>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "8px",
              }}
            >
              <FontAwesomeIcon
                icon={faClock}
                style={{ marginRight: "5px", color: "lightblue" }}
              />
              <Typography variant="body1">
                Current Response Day: {data.responseDay}
              </Typography>
            </div>
            <Input
              type="number"
              value={responseDayInput}
              onChange={(e) => setResponseDayInput(e.target.value)}
              placeholder="Enter Response Day"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={updateResponseDayHandler}
            disabled={responseDayLoader || Number(responseDayInput) <= 0}
            style={{ display: "flex", gap: "2px" }}
          >
            {responseDayLoader && <Spinner size="sm" />}
            Submit
          </Button>{" "}
          <Button
            color="secondary"
            onClick={toggleResponseDayModal}
            disabled={responseDayLoader}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal for notify Applicant */}
      <Modal
        isOpen={applicantsNotifyModal}
        toggle={handleapplicantsNotifyModal}
      >
        <ModalHeader toggle={handleapplicantsNotifyModal}>
          Enter your message
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="message">Message</Label>
              <Input
                type="textarea"
                name="message"
                id="message"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleapplicantsNotifyModal}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={notifyApplicantsHandler}
            disabled={notifyLoader}
          >
            {notifyLoader ? <Spinner size="sm" /> : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AnnouncementDetail;
